import { Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function Footer() {
    const navigate = useNavigate();

    return (
        <footer className="py-4 border-t border-black/5 dark:border-white/5 text-sm text-muted-foreground bg-background">
            <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-6">
                <div className="flex items-center gap-2">
                    <div className="w-6 h-6 bg-black/5 dark:bg-white/10 rounded flex items-center justify-center">
                        <Shield className="w-3 h-3 text-foreground dark:text-white" />
                    </div>
                    <span className="font-semibold text-foreground">TalentSync</span>
                </div>

                <div className="flex gap-8">
                    <button onClick={() => navigate('/privacy')} className="hover:text-foreground transition-colors">Privacy</button>
                    <button onClick={() => navigate('/contact')} className="hover:text-foreground transition-colors">Contact</button>
                </div>

                <div>
                    &copy; {new Date().getFullYear()} TalentSync. All rights reserved.
                </div>
            </div>
        </footer>
    );
}
